import { gql } from "lib/apolloClient";
import { studentsAlertFragment } from "modules/CommonFragments";
import {
  projectDetailFragment,
  projectFieldFragment,
} from "../../../modules/AssessmentFragments";

export const gradebookInfoFragment = gql`
  fragment gradebookInfo on Project {
    id
    students {
      id
      profileImage
      firstName
      middleName
      lastName
      preferredName
      suffix
      pronouns
      alertTypes {
        ...alertTypeFields
      }
    }
    ibPYPElementRatings {
      id
      ibPYPElementId
      ibPYPElementType
      value
      academicCriteriaSet {
        id
        label
        criteriaType
      }
      academicCriteriaValue {
        id
        label
        abbreviation
      }
    }
    ibPYPElementRemarks {
      id
      message
      ibPYPElementId
      ibPYPElementType
    }
    toolResponses(userFilter: ALL) {
      id
      rowId
      columnId
      subjectiveResponse
      creatorType
    }
    ...projectDetailItem
  }
  ${projectDetailFragment}
  ${studentsAlertFragment}
`;

export const individualGradebookInfoFragment = gql`
  fragment individualGradebookInfo on Project {
    id
    studentCollaborators {
      id
      student {
        id
        profileImage
        firstName
        middleName
        lastName
        preferredName
        suffix
        pronouns
        alertTypes {
          ...alertTypeFields
        }
      }
      ibPYPElementRatings {
        id
        ibPYPElementId
        ibPYPElementType
        value
        academicCriteriaSet {
          id
          label
          criteriaType
        }
        academicCriteriaValue {
          id
          label
          abbreviation
        }
      }
      ibPYPElementRemarks {
        id
        message
        ibPYPElementId
        ibPYPElementType
      }
      toolResponses(userFilter: ALL) {
        id
        rowId
        columnId
        subjectiveResponse
        creatorType
      }
      assessmentRemarks {
        id
        message
        isLocked
        lockingState {
          state
        }
      }
      fields(filters: $projectFieldFilters) {
        ...projectFieldItem
      }
    }
    ...projectDetailItem
  }
  ${projectFieldFragment}
  ${projectDetailFragment}
  ${studentsAlertFragment}
`;
